module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/4-46fb4ea36ce1da99018f457d6307ff9d.png";